import { useMemo } from 'react';

import { AppThemeConfig, appThemeConfig } from '@/theme/appThemeConfig';
import { appThemeConfigDarkMode } from '@/theme/appThemeConfigDarkMode';
import { ThemeMode, useAppThemeStore } from '@/theme/useAppThemeStore';

export const useGetThemeConfig = (): [AppThemeConfig, ThemeMode] => {
  const themeMode = useAppThemeStore(state => state.themeMode);

  return useMemo(
    () => [themeMode === 'dark' ? appThemeConfigDarkMode : appThemeConfig, themeMode],
    [themeMode]
  );
};
